import * as React from "react";
import { Component } from "react";
import ModalPanel from "Panels/ModalPanel";
import Button from "Components/Buttons/Button";
import { Alert } from "@mui/lab";

interface UserCreatedSuccessModalProps {
    shouldBeShown: boolean;
    username: string;
    email: string;
    password: string;
    onClose(): void;
}

interface UserCreatedSuccessModalState {
    copied: boolean;
}

export default class UserCreatedSuccessModal extends Component<UserCreatedSuccessModalProps, UserCreatedSuccessModalState> {
    constructor(props: UserCreatedSuccessModalProps) {
        super(props);
        this.state = {
            copied: false
        };
    }

    render() {
        const { shouldBeShown, username, email, password } = this.props;
        const { copied } = this.state;

        return (
            <ModalPanel
                content={
                    <div style={{ minWidth: 400 }}>
                        <Alert severity="success" style={{ marginBottom: 16 }}>
                            User account created successfully!
                        </Alert>

                        <div style={{ marginBottom: 16 }}>
                            <p><strong>Username:</strong> {username}</p>
                            <p><strong>Email:</strong> {email}</p>
                            <p><strong>Password:</strong> {password}</p>
                            <p style={{ fontSize: "0.9em", color: "#666", marginTop: 12 }}>
                                Please share these credentials with the user securely. They should change their password after first login.
                            </p>
                        </div>

                        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                            <Button
                                label={copied ? "Copied!" : "Copy Details"}
                                onClick={() => this.copyToClipboard()}
                            />
                            <Button
                                label="Send Email"
                                onClick={() => this.sendEmail()}
                            />
                            <Button
                                label="Close"
                                onClick={() => this.handleClose()}
                            />
                        </div>
                    </div>
                }
                title="User Created"
                titleAlignment="centre"
                onClose={() => this.handleClose()}
                shouldBeShown={shouldBeShown}
            />
        );
    }

    private handleClose() {
        this.setState({ copied: false });
        this.props.onClose();
    }

    private async copyToClipboard() {
        const { username, email, password } = this.props;
        const text = `iDART Account Created

Username: ${username}
Email: ${email}
Password: ${password}

You can now log in to iDART using these credentials.
Please change your password after your first login.`;

        try {
            await navigator.clipboard.writeText(text);
            this.setState({ copied: true });
            setTimeout(() => this.setState({ copied: false }), 2000);
        } catch (err) {
            console.error("Failed to copy to clipboard:", err);
        }
    }

    private sendEmail() {
        const { username, email, password } = this.props;

        const subject = encodeURIComponent("Your iDART Account Has Been Created");
        const body = encodeURIComponent(`Hello,

Your iDART account has been created with the following details:

Username: ${username}
Temporary Password: ${password}

Please log in to iDART and you will be prompted to change your password on first login.

Best regards`);

        window.open(`mailto:${email}?subject=${subject}&body=${body}`, "_blank");
    }
}
